import { axios } from "../../helper/axios";
import { FaqConstant } from "./FaqConstant";

const FaqApi = {};

// faq category api
FaqApi.getFaqCategories = (payload) => {
  const { parent_id = null, id = null } = payload || {};
  const { content_type = null } = payload || {};

  let queryParam = "";
  if (parent_id !== null) {
    queryParam += `parent_id=${parent_id}`;
  }
  if (content_type !== null) {
    queryParam += `&content_type=${content_type}`;
  }
  if (id !== null) {
    queryParam += `id=${id}`;
  }

  if (queryParam.endsWith("&")) {
    queryParam = queryParam.slice(0, -1);
  }

  return axios.get(`${FaqConstant.FAQ_CATEGORIES_API}?${queryParam}`);
};


FaqApi.getFaqParentCategories = ({ parent_id,content_type }) => {

 
  let queryParam = "";
  if (parent_id !== undefined && parent_id !== null) {
    queryParam += `parent_id=${parent_id}`;
  }
  if (content_type !== undefined && content_type !== null) {
    queryParam += `&content_type=${content_type}`;
  }
  if (queryParam.endsWith("&")) {
    queryParam = queryParam.slice(0, -1);
  }
  return axios.get(`${FaqConstant.FAQ_CATEGORIES_API}?${queryParam}`);
};

FaqApi.postFaqCategoriesApi = (payload) => {
  return axios.post(FaqConstant.POST_FAQ_CATEGORIES_API, payload);
};

FaqApi.UpdateFaqCategoriesApi = (payload) => {
  return axios.put(FaqConstant.UPDATE_FAQ_CATEGORIES_API, payload);
};

//enable-disable categories
FaqApi.FaqCategoriesStatusApi = ({ id, status }) => {
  return axios.put(FaqConstant.FAQ_CATEGORIES_STATUS_API, {
    id: id,
    status: status,
  });
};

FaqApi.FaqCategoriesDeleteApi = (id) => {
  return axios.delete(FaqConstant.FAQ_CATEGORIES_DELETE_API.replace(":id", id));
};


// faq api

FaqApi.getFaq = ({ id, status, category_id, subcategory_id ,content_type,search }) => {
  let queryParam = "";
  if (status !== undefined && status !== null) {
    queryParam += `status=${status}&`;
  }
  if (content_type !== undefined && content_type !== null) {
    queryParam += `content_type=${content_type}&`;
  }
  if (category_id !== undefined && category_id !== null) {
    queryParam += `category_id=${category_id}&`;
  }
  if (subcategory_id !== undefined && subcategory_id !== null) {
    queryParam += `subcategory_id=${subcategory_id}`;
  }
  if (id !== undefined && id !== null) {
    queryParam += `id=${id}`;
  }
  if (search !== undefined && search !== null) {
    queryParam += `search=${search}`;
  }
  
  if (queryParam.endsWith("&")) {
    queryParam = queryParam.slice(0, -1); // remove trailing &
  }
  

  return axios.get(`${FaqConstant.FAQ_API}?${queryParam}`);
};

FaqApi.postFaqApi = (payload) => {
  return axios.post(FaqConstant.FAQ_POST_API, {
    category_id: payload.category_id,
    subcategory_id: payload.subcategory_id,
    question: payload.question,
    answer: payload.answer,
    keywords: payload.keywords,
    content_type:payload.content_type,
  });
};

//delete faq api
FaqApi.deleteFaqApi = (id) => {

  return axios.delete(FaqConstant.FAQ_DELETE_API.replace(":id", id));
};

FaqApi.UpdateFaqApi = (payload) => {
  return axios.put(FaqConstant.FAQ_UPDATE_API, {
    id: payload.id,
    category_id: payload.category_id,
    subcategory_id: payload.subcategory_id,
    question: payload.question,
    answer: payload.answer,
    status:payload.status,
  });
};

//faq-keywords

FaqApi.getFaqKeywordApi = ({ question_id }) => {
  let queryParam = "";
  if (question_id !== undefined && question_id !== null) {
    queryParam += `question_id=${question_id}&`;
  }
  if (queryParam.endsWith("&")) {
    queryParam = queryParam.slice(0, -1); // remove trailing &
  }
  return axios.get(`${FaqConstant.GET_FAQ_KEYWORD_API}?${queryParam}`);
};

FaqApi.postFaqKeywordApi = (payload) => {
  return axios.post(FaqConstant.POST_FAQ_KEYWORD_API, payload);
};

FaqApi.updateFaqKeywordApi = (payload) => {
  return axios.put(FaqConstant.UPDATE_FAQ_KEYWORD_API, payload);
};
FaqApi.deleteFaqKeywordApi = (id) => {
  return axios.delete(FaqConstant.DELETE_FAQ_KEYWORD_API.replace(":id", id));
};

export { FaqApi };
